import { faEdit, faTractor, faTrash } from "@fortawesome/free-solid-svg-icons"
import { Fragment, useEffect, useState } from "react"
import Skeleton from "react-loading-skeleton"
import { useDispatch, useSelector } from "react-redux"
import { Link, useNavigate } from "react-router-dom"
import Backdrop from "../../../Backdrop"
import Filter from "./desktop/filter"
import Resort from './desktop/resort'
import InfoIcon from "../../../InfoIcon"
import useFetch from "../../../../hook/useFetch"
import { notificationActions } from "../../../../store/notification-slice"


export default function DesktopComponent() {


    const [desktopItems, setDesktopItems] = useState()


    let filteredproductypes = useSelector((state) => state.producttype.filteredProducttypes)

    let dispatch = useDispatch()



    let stateproducttypes = useSelector(state => state.producttype.producttypes)


    useEffect(() => {

        let items = []
        let producttypes = filteredproductypes ?? stateproducttypes

        if (producttypes && Object.keys(producttypes).length > 0) {

            producttypes.forEach((producttype) => {

                items.push(<DesktopItem key={producttype.id} producttype={producttype} />)

            })
        }
        setDesktopItems(items)



    }, [filteredproductypes, stateproducttypes])


    if (!desktopItems) {
        return <Skeleton count={50} />
    }

    return <Fragment>
        <Filter>

            <table className="table table-striped table-bordered" >
                <thead>
                    <tr>

                        <th>id <Resort type='id' /></th>
                        <th>title <Resort type='title' /></th>

                        <th>CreatedOn <Resort type='created_on' /></th>

                        <th>Details</th>
                        <th>Delete</th>


                    </tr>
                </thead>
                <tbody>
                    {desktopItems}
                </tbody>
            </table>
        </Filter>
        <Backdrop />

    </Fragment>
}


function DesktopItem(props) {
    const { producttype } = props
    const { del } = useFetch()
   
    let dispatch = useDispatch()
    let navigate = useNavigate()

    return <Fragment>

        <tr>

            <td>
                {producttype.id}
            </td>
            <td>
                {producttype.title}
            </td>

            <td>
                {producttype.created_on}
            </td>
            <td>
                <Link  className="btn btn-outline-secondary bgnt" to={`/admin/producttypes/${producttype.id}`} ><InfoIcon icon={faEdit} title='producttype details' /></Link>
            </td>
            <td>
                <button disabled={producttype.id===1} type="button" className="btn btn-warning" onClick={() => {
                    del(`/admin/producttype`, { id: producttype.id }, (data) => {
                        dispatch(notificationActions.setNotification({
                            message: data,
                            status: false
                        }))
                    },
                        (data) => {
                            console.log(data)
                            dispatch(notificationActions.setNotification({
                                message: `producttype deleted`,
                                status: true
                            }))


                            navigate('/admin/producttypes', {
                                state: {
                                    refetch: true
                                }
                            })
                        }
                    )
                }} ><InfoIcon icon={faTrash} title='delete producttype' /></button>
            </td>



        </tr>

    </Fragment>

}